import React, { useState } from "react";
import { Upload as AntdUpload } from "antd";
import { get } from "lodash";
import { UploadProps } from "antd/lib/upload/Upload";
import UploadServices from "./services/UploadServices";

interface IProp extends UploadProps {
  children?: any;
  onProgress?: any;
  onSuccess?: any;
  url?: string;
  extraData?: object;
}

const Upload = (props: IProp) => {
  const {
    onProgress: onProgressProp = () => {},
    onSuccess = () => {},
    url = "",
    extraData,
  } = props;

  const [progressPercent, setProgressPercent] = useState<number>(0);

  const customRequest = async (propFile: any) => {
    const {
      // action,
      // data,
      file,
      filename,
      // headers,
      // onError,
      onProgress,
      // onSuccess,
      // withCredentials
    } = propFile;

    const formData = new FormData();
    formData.append(filename, file);

    if (extraData) {
      for (const keyData in extraData) {
        formData.append(keyData, get(extraData, keyData));
      }
    }

    const res = await UploadServices.uploadFile(url, formData, (e: any) => {
      const percent = Number(Math.round((e.loaded / e.total) * 100).toFixed(2));
      onProgress({ percent }, file);
      onProgressProp(percent);
      setProgressPercent(percent);
    });

    onSuccess(res, file);
  };

  const onChangeUpload = ({ file, fileList }: any) => {};

  return (
    <AntdUpload
      customRequest={customRequest}
      onChange={onChangeUpload}
      // itemRender={(origin, file, currFileList) => {
      //   console.log({ origin, file, currFileList });
      //   return <div></div>;
      // }}
      {...props}
    />
  );
};

export default Upload;
